import React from "react";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {CyClass} from "../../../common/cy-classes";
import {DialogBoldTextBox, DialogTextBox} from "../modal-dialog/boxes/text/dialog-text.box";
import {ModalDialogActionsComponent} from "../modal-dialog/modal-dialog-actions.component";
import {LoginPopupBox} from "./boxes/login-popup.box";
import {LoginPopupDialogText} from "./boxes/login-popup-dialog-text.box";
import {ILoginPopupData} from "../../services/login-popup/login-popup.service.interface";
import {observer} from "mobx-react";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {useServices} from "../../react-hooks/use-services.hook";
import {withServices} from "../../react-hooks/with-services";

interface ILoginPopupComponentProps extends ComponentServicesPick<'loginPopup'>{
    dialogHandler: IModalDialogHandler;
    onApprove: ()=> void
}

const ComponentBody: React.FC<ILoginPopupComponentProps> = observer((props) => {
    const services = useServices();
    const _onOkPressed = () => {
        props.onApprove && props.onApprove();
        props.dialogHandler && props.dialogHandler.close();
    };

    const data: ILoginPopupData = props.loginPopup.getLoginPopupData();
    let totalStakesText: string;
    let netPositionText: string;

    // No available data
    if(!data || data.BankrollCurr === 'NA') {
        totalStakesText = services.translation.translate("LOGIN_POPUP_NO_AVAILABLE_DATA");
        netPositionText = services.translation.translate("LOGIN_POPUP_NO_AVAILABLE_DATA");
    } else {
        totalStakesText = services.currency.formatMoney(data.TotalStakes);
        netPositionText = services.currency.formatMoney(data.NetPosition);
    }

    return (
        <LoginPopupBox className={CyClass('cy-login-modal-content')}>
            <DialogBoldTextBox>{services.translation.translate("LOGIN_POPUP_TOP_TEXT")}</DialogBoldTextBox>
            <LoginPopupDialogText>{services.translation.translate("LOGIN_POPUP_TOTAL_BETS_TEXT")}</LoginPopupDialogText>
            <LoginPopupDialogText className={CyClass('cy-login-popup-total-stakes')}>{totalStakesText}</LoginPopupDialogText>
            <DialogTextBox>{services.translation.translate("LOGIN_POPUP_NET_POSITION_TEXT")}</DialogTextBox>
            <LoginPopupDialogText className={CyClass('cy-login-popup-net-position')}>{netPositionText}</LoginPopupDialogText>

            <ModalDialogActionsComponent
                primaryAction={{
                    text: services.translation.translate("OK"),
                    onClick: _onOkPressed,
                    className: CyClass('cy-state-select-approve-button')
                }}
            />
        </LoginPopupBox>
    );
    
})

export const LoginPopupComponent = withServices(ComponentBody, ['loginPopup']);